module.exports = __webpack_public_path__ + "fonts/239abe3.woff";